import { Text } from "../../config/Constants";

export type PushNotificationFields = {
  title: string;
  body: string;
  deepLinkId: string;
  category: string;
  enableDL: boolean;
};
type Error = (a: any) => void;

export const Validation = (user: PushNotificationFields, setError: Error) => {
  let error = {};
  if (user.title === "") {
    // @ts-ignore
    error["title"] = Text.subjectEnterText;
  }
  if (user.body === "") {
    // @ts-ignore
    error["body"] = Text.messageEnterText;
  }
  if (user?.enableDL && user?.category && user?.category !== "home" && user?.deepLinkId === '') {
    // @ts-ignore
    error["deepLinkId"] = "Select a deeplink target";
  }

  setError(error);
  return areAllKeysEmpty(error);
};

function areAllKeysEmpty(obj: any) {
  for (let key in obj) {
    if (obj.hasOwnProperty(key) && obj[key] !== "") {
      return false;
    }
  }
  return true;
}
